import { Component, Inject, ViewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { CreateEntityComponent, EntityAddedEvent } from 'entity/components/create-entity/create-entity.component';

import { EntityCore } from 'generated/graphql';

/**
 * Format of data for the dialog
 */
export interface CreateEntityDialogData {
  campaignId: string;
  /**
   * Optional: if set, this will override the default entity type
   * for the campaign
   */
  initialEntityTypeId?: string;
}

@Component({
  selector: 'app-create-entity-dialog',
  templateUrl: './create-entity.dialog.html'
})
export class CreateEntityDialog {
  @ViewChild(CreateEntityComponent, { static: true }) createEntityComponent: CreateEntityComponent;

  static open(dialog: MatDialog, config: MatDialogConfig<CreateEntityDialogData>) {
    config.autoFocus = '[data-focus-id="firstName"]';
    return dialog.open<CreateEntityDialog, CreateEntityDialogData, EntityCore.Fragment>
      (CreateEntityDialog, config);
  }

  constructor(
    private matDialog: MatDialog,
    public dialogRef: MatDialogRef<CreateEntityDialog>,
    @Inject(MAT_DIALOG_DATA) public data: CreateEntityDialogData
  ) { }

  closeDialogClicked() {
    if (this.createEntityComponent.formGroup.dirty) {
      const shouldClose = confirm('You have unsaved changes, are you sure you want to close?');
      if (shouldClose) {
        this.close();
      }
    } else {
      this.close();
    }
  }

  entityAdded(event: EntityAddedEvent) {
    this.close(event.entity);
    if (event?.addAnother && event.entity) {
      CreateEntityDialog.open(this.matDialog, {
        data: {
          campaignId: this.data.campaignId,
          initialEntityTypeId: event.entity.entityTypeId
        }
      });
    }
  }

  close(entity: EntityCore.Fragment = null) {
    this.dialogRef.close(entity);
  }
}
